const TagHighlightEntityColumn = {
  TestSessionNote: 'note',
  TestSessionAnswer: 'transcript_text',
  TestSessionSpeaker: 'text',
};

export default TagHighlightEntityColumn;
